import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { PlayerContext } from '../components/Player/Store/PlayerContext'
import { getParameterByName, isAppWarmup } from '../utils'
import { useOttPlayer } from '../Ott/contexts/providers/OttPlayerProvider'
import { useRouter } from 'next/router'
import { usePage } from '../contexts'

const REFRESH_TIME = 7 * 60 * 1000

const pagesTypeRefresh = [
  'hp',
  'item',
  'recepie',
  'live',
  'tag',
  'writer',
  'category',
  'grid',
  'mivzakim',
  'tvguide',
  '404',
  'live_26',
]
const checkPageTypeRefresh = (pageType: string) => {
  return pagesTypeRefresh.includes(pageType)
}
export default function AutoRefresh() {
  const router = useRouter()
  const { videoPlaying: ottPlayerPlaying } = useOttPlayer()
  const { videoPlaying } = useContext(PlayerContext)
  const providedPage = usePage()
  const timerRef = useRef<NodeJS.Timeout | null>(null)
  const [isAutoRefresh, setIsAutoRefresh] = useState(false)
  const [refreshTimeOut, setRefreshTimeOut] = useState(REFRESH_TIME)

  useEffect(() => {
    const refresh_time_param = getParameterByName('refresh_time')
    if (refresh_time_param) {
      setRefreshTimeOut(Math.max(2, parseInt(refresh_time_param)) * 60 * 1000)
    }
  }, [])

  useEffect(() => {
    // App prefetch: each refresh would count as another page view
    if (isAppWarmup()) {
      return setIsAutoRefresh(false)
    }
    const haseTerrific = !!document.querySelector('#terrific-timeline-div')
    const minutly_is_playing = !!getParameterByName('mly_reel')
    if (haseTerrific || minutly_is_playing) {
      return setIsAutoRefresh(false)
    }
    if (!providedPage || Object.keys(providedPage).length === 0) {
      return setIsAutoRefresh(true)
    }
    return setIsAutoRefresh(
      checkPageTypeRefresh(providedPage.PageMeta?.pageType || '') &&
        providedPage.PageMeta.is_auto_refresh
    )
  }, [providedPage])

  const startTimer = useCallback(() => {
    // Clear existing timer
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    // Only start timer if no video is playing
    if (!videoPlaying && !ottPlayerPlaying && isAutoRefresh) {
      timerRef.current = setTimeout(() => {
        const players = window.KalturaPlayer.getPlayers()
        const isAnyPlaying = Object.keys(players).reduce((isPlaying, key) => {
          try {
            return isPlaying || !window.KalturaPlayer.getPlayer(key)?.paused
          } catch (e) {
            return isPlaying
          }
        }, false)
        if (isAnyPlaying) {
          return
        }
        window.location.reload()
      }, refreshTimeOut)
    }
  }, [isAutoRefresh, ottPlayerPlaying, refreshTimeOut, videoPlaying])

  useEffect(() => {
    startTimer()
  }, [startTimer])

  useEffect(() => {
    const timerId = timerRef.current
    const onRouteChangeStart = () => {
      startTimer()
    }
    router.events.on('routeChangeStart', onRouteChangeStart)
    return () => {
      timerId && clearTimeout(timerId)
      router.events.off('routeChangeStart', onRouteChangeStart)
    }
  }, [ottPlayerPlaying, router.events, startTimer, videoPlaying])

  return null
}
